module.exports = __webpack_public_path__ + "img/OT003.7e308c3.webp";